export default __webpack_public_path__ + "static/beatrice-ee15657afed9007c90aad296fab21ae7.webp";